import { lazy, memo, Suspense, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { EMBED_VARIANTS } from "../../../utils/helper";
import Insights from "../../Dashboard/Insights/Insights";
import Header from "../../Header";
import MapContainer from "../../MapContainer";
import Reports from "../../Report/new/Reports";
import { MOBILE_SCREENS } from "../App";
import {
  StyledApp,
  StyledLoader,
  StyledMapSurveyContainer,
} from "../App-styled";

const MobileList = lazy(() => import("../../MobileList"));
const MobilePopup = lazy(() =>
  import("../../MobileApp/MobilePopup/MobilePopup")
);

const MobileApp = ({
  config,
  view,
  openSnackbar,
  activeLanguage,
  setActiveLanguage,
}) => {
  const [mobileScreen, setMobileScreen] = useState(MOBILE_SCREENS.MAP);

  const { t } = useTranslation("common");
  let { activeModule } = useSelector((store) => store);

  const ref = useRef();
  const isAppEmbed = useMemo(
    () => config?.embed === EMBED_VARIANTS.APP,
    [config]
  );

  return (
    <StyledApp data-testid="app-main">
      {!isAppEmbed && view && (
        <Suspense>
          <Reports
            config={config}
            t={t}
            openSnackbar={openSnackbar}
            activeLanguage={activeLanguage}
          />
        </Suspense>
      )}

      {view && (
        <Header mobileScreen={mobileScreen} setMobileScreen={setMobileScreen} />
      )}
      <StyledMapSurveyContainer
        style={{
          display: mobileScreen === MOBILE_SCREENS.MAP ? "flex" : "none",
        }}
        ref={ref}
        id="mapContainer"
        className={`mobile__app ${
          isAppEmbed ? "mobile__app--embed" : "mobile__app--not-embed"
        }`}
      >
        <Suspense fallback={<StyledLoader />}>
          <MapContainer
            style={{
              display: mobileScreen === MOBILE_SCREENS.MAP ? "flex" : "none",
            }}
            id="map-container"
            activeModule={activeModule}
            activeLanguage={activeLanguage}
            setActiveLanguage={setActiveLanguage}
          />
        </Suspense>
      </StyledMapSurveyContainer>
      {MOBILE_SCREENS.INSIGHTS === mobileScreen && (
        <div
          style={{
            marginTop: 70,
            width: "100%",
            position: "relative",
            background: "#fff",
            height: "100%",
            display: "flex",
          }}
        >
          <Insights
            expand={true}
            showSidebar={() => {}}
            closeSidebar={() => {}}
          />
        </div>
      )}
      {view && (
        <Suspense>
          <MobileList config={config} mobileScreen={mobileScreen} />
        </Suspense>
      )}
      {view && (
        <Suspense>
          <MobilePopup />
        </Suspense>
      )}
    </StyledApp>
  );
};

export default memo(MobileApp);
